import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tw-flex tw-flex-col tw-justify-center tw-items-center",
    attrs: {
      "id": "mcn-not-fount"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('page_not_found')))]), _c(VBtn, {
    staticClass: "tw-mt-4",
    staticStyle: {
      "color": "black",
      "text-decoration": "none"
    },
    attrs: {
      "color": "white",
      "to": `/${_vm.$i18n.locale}`,
      "large": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('global_text.go_home')))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };